import { LeadInboundDealType } from '@trnsact/trnsact-shared-types';
import { MUIBaseEntity, MUITableColumn } from 'components/shared/MUITable';
import { Optional, TabsOption } from 'global';

export enum OpportunitiesListTabs {
  MyOpportunities = 'myOpportunities',
  AllOpportunities = 'allOpportunities',
  Unassigned = 'unassigned',
  DealPipeline = 'dealPipeline',
  StagesReport = 'stagesReport',
}

export type OpportunitiesListTabsType = OpportunitiesListTabs | string;

export interface OpportunityListTableEntity extends MUIBaseEntity {
  id: string;
  createdOn: string;
  businessProcessFlowsView?: any;
  creditTiersResult?: any;
  fastTrack?: any;
  customerName?: string;
  contactName?: string;
  mainSignor?: string;
  applicationStage?: string;
  transactionStage?: string;
  entityType?: string;
  invoiceTotal?: string;
  salesRep?: string;
  salesManager?: string;
  financeManager?: string;
  location?: string;
  equipmentDetails?: string;
  invoiceStatus?: string;
  statusDetail?: string;
  applicationType?: string;
  applyingFor?: string;
  displayStatus?: number;
  inboundDealType?: LeadInboundDealType;
  dealerName?: string;
  partnerRepName?: string;
  partnerLogo?: string;
  vendorProfileId?: string;
  sourceVendorProfileId?: string;
}

export interface GetOpportunitiesTableDealerColumnsProps {
  bpfTemplates: unknown[];
  isTiersResultsHidden: boolean;
  allowManualVoCreation: boolean;
  isMultiLocationManagementEnabled: boolean;
}

export interface GetOpportunitiesTablePartnerColumnsProps {
  bpfTemplates: unknown[];
}

export enum ApplicationStageLabels {
  pre_qualified = 'Prequalified',
  dealer_cancelled = 'Dealer Cancelled',
  customer_cancelled = 'Customer Cancelled',
}

export enum OpportuinitiesBaseColumns {
  CREATED_ON = 'CREATED_ON',
  BUSINESS_PROCESS_FLOWS = 'BUSINESS_PROCESS_FLOWS',
  CUSTOMER = 'CUSTOMER',
  STAGE = 'STAGE',
  STATUS = 'STATUS',
  AMOUNT = 'AMOUNT',
  SALES_REP = 'SALES_REP',
  SALES_MANAGER = 'SALES_MANAGER',
  FINANCE_MANAGER = 'FINANCE_MANAGER',
  EQUIPMENT_DETAILS = 'EQUIPMENT_DETAILS',
  INVOICE_STATUS = 'INVOICE_STATUS',
  DEAL_TYPE = 'DEAL_TYPE',
}

export enum OpportuinitiesDealerColumns {
  TIER = 'TIER',
  SOURCE = 'SOURCE',
  CONTACT = 'CONTACT',
  MAIN_SIGNOR = 'MAIN_SIGNOR',
  OPPORTUNITY_TYPE = 'OPPORTUNITY_TYPE',
  LOCATION = 'LOCATION',
  STATUS_DETAIL = 'STATUS_DETAIL',
  APPLICANT_TYPE = 'APPLICANT_TYPE',
  APPLYING_FOR = 'APPLYING_FOR',
  DISPLAY = 'DISPLAY',
}

export enum OpportuinitiesPartnerColumns {
  DEALER_NAME = 'DEALER_NAME',
  PARTNER_REP = 'PARTNER_REP',
}

export interface OpportunitiesTableColumn extends MUITableColumn<OpportunityListTableEntity> {
  isHidden?: boolean;
}

export interface TabInitialConfig extends Optional<TabsOption<OpportunitiesListTabsType>, 'component'> {}
